<template>
  <router-link
    v-if="!isCTA"
    :to="view.startLinkParams(doc)"
    class="books__item"
    :class="doc.id"
  >
    <div class="books__icons">
      <BookListenIcon v-if="doc.has_audio" />
      <FreeBookIcon v-if="doc.is_free && showFreeBooks" />
    </div>

    <div class="books__link">
      <BookCardThumbnail
        class="books__img-box"
        coverClass="books__img"
        fallbackCoverClass="books__img"
        :doc="doc"
        :cacheBust="true"
      />

      <div class="books__progress progress">
        <div
          :aria-valuenow="doc.progress"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="{ width: doc.progress + '%' }"
          class="progress__now"
        />
      </div>
      <div class="books__text-box">
        <div class="books__text">
          <div class="books__wrapper">
            <h5 class="books__category card__category">
              {{ view.firstTag(doc) }}
            </h5>
            <DocListsMenu :doc="doc" :docsView="view" />
          </div>
          <h3 class="books__title card__title">{{ doc.title }}</h3>
          <h4 class="books__author card__author">By {{ doc.author }}</h4>
        </div>
        <CustomListDocMenu
          v-if="showCustomListActions && customList"
          class="books__actions books__actions--list-page"
          :doc="doc"
          :docsView="view"
          :list="customList"
          position="right"
        />
        <DocLibraryMenu
          v-else-if="view.showActionsButton"
          class="books__actions books__actions--library"
          :doc="doc"
          :docsView="view"
          position="right"
        />
      </div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import DocListsMenu from '@/app/components/doc/DocListsMenu.vue'
import BookListenIcon from '@/app/components/book/card/BookListenIcon.vue'
import FreeBookIcon from '@/app/components/book/card/FreeBookIcon.vue'
import BookCardThumbnail from '@/app/components/book/card/BookCardThumbnail.vue'
import DocLibraryMenu from '@/app/components/doc/DocLibraryMenu.vue'
import CustomListDocMenu from '@/app/components/custom.lists/CustomListDocMenu.vue'

import { BookListItem, CustomList } from '@/models/interfaces'
import { BooksView } from '@/models/doc.book'

const props = withDefaults(
  defineProps<{
    doc: BookListItem
    view: BooksView
    showFreeBooks?: boolean
    customList?: CustomList
  }>(),
  {
    showFreeBooks: true,
  },
)

const isCTA = computed(() => {
  return props.doc.title === 'CTA'
})

const showCustomListActions = computed(() => {
  return (
    props.view.showActionsButton && props.customList?.doc_type === 'custom_list'
  )
})
</script>

<style lang="scss" scoped>
.books {
  &__actions {
    position: absolute;
    right: 16px;
    bottom: 16px;
    width: fit-content;
  }
}
</style>
